export enum LogoImageType {
  Main = 'main',
  TopMenu = 'top_menu',
  Footer = 'footer',
}

export type VersionInfo = {
  release_version: string | null
  transform_version: string | null
  broker_version: string | null
  webservice_version: string | null
  webservicefront_version: string | null
}

export type TutorialLink = {
  name: string
  url: string
}
